import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCfKs2GOxPzv73KOzwUwFIZBRi48VFcePI",
  authDomain: "razcofoods.firebaseapp.com",
  projectId: "razcofoods",
  storageBucket: "razcofoods.firebasestorage.app",
  messagingSenderId: "753470294969",
  appId: "1:753470294969:web:561724113e217e7f690468",
  measurementId: "G-53BQ1QVD6G",
};

let app;
let messagingPromise;

export function getFirebaseApp() {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
}

export async function getFirebaseMessaging() {
  if (!messagingPromise) {
    messagingPromise = (async () => {
      const supported = await isSupported();
      if (!supported) return null;
      const m = getMessaging(getFirebaseApp());
      return m;
    })();
  }
  return messagingPromise;
}
